import Cards from "../Cards";

const LongFormVideos = () => {
  const items = [
    [
      "vidsource1",
      "https://drive.google.com/file/d/1bX5JGEzPfx6CEMzskJ6T4HKl8EdHAzV6/preview",
    ],
    [
      "vidsource2",
      "https://drive.google.com/file/d/1E_k4tC-XmVEL3rfBkdk9Qzm-HOdnO5SV/preview",
    ],
    [
      "vidsource3",
      "https://drive.google.com/file/d/13f-IyEC9eyJT5JQnh-BvN-a1KWDxPy0F/preview",
    ],
    [
      "vidsource4",
      "https://drive.google.com/file/d/157FWlGKVh4QIPyNgWv6MjgykuD0NcKvJ/preview",
    ],
  ];
  return (
    <div className="flex flex-col gap-y-5 z-1 bg-bg-primary">
      <div>
        <h1 className="italic font-bold">Long Form Videos</h1>
      </div>
      <div className="w-full sm:grid sm:grid-cols-2 sm:grid-rows-2 gap-5">
        {items.map(([key, s]) => (
          <Cards url={s} key={key} />
        ))}
      </div>
    </div>
  );
};

export default LongFormVideos;
